
var template1Default =
{
  templateName: "templates1",
  templateCN: "产品模板1",
  FirstTitle: "大标题",
  subTitle: "二级标题",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "小标题", remark: "", field: "subTitle", type: "text" },

  ],
  field: [
    { name: "图标", remark: "建议24*24尺寸", field: "icon", type: "image" },
    { name: "产品名称", remark: "50字", field: "title", type: "text" },
    { name: "介绍", remark: "50字", field: "introduce", type: "text" },
    { name: "跳转链接", remark: "", field: "url", type: "text" },
    { name: "展示图片", remark: "", field: "showImage", type: "image" },
  ],
  children: [
    {
      icon: "https://www.wsgjp.com.cn/Products/img/index/product_nav_1_active.png",
      title: "示例1",
      showImage:
        "https://www.wsgjp.com.cn/Products/img/index/product_content_3.png",
      introduce: "文本介绍",
      url: "aaaaa",
    },
    {
      icon: "	https://www.wsgjp.com.cn/Products/img/index/product_nav_2_active.png",
      title: "示例2",
      showImage:
        "	https://www.wsgjp.com.cn/Products/img/index/product_content_2.png",
      introduce: "文本介绍",
      url: "aaaaa",
    },
    {
      icon: "	https://www.wsgjp.com.cn/Products/img/index/product_nav_3_active.png",
      title: "示例3",
      showImage:
        "	https://www.wsgjp.com.cn/Products/img/index/product_content_3.png",
      introduce: "文本介绍",
      url: "aaaaa",
    },
    {
      icon: "		https://www.wsgjp.com.cn/Products/img/index/product_nav_4_active.png",
      title: "示例3",
      showImage:
        "	https://www.wsgjp.com.cn/Products/img/index/product_content_4.png",
      introduce: "文本介绍",
      url: "aaaaa",
    },

  ],
}

var template2Default =
{
  templateName: "templates2",
  templateCN: "产品模板2",
  FirstTitle: "大标题",
  subTitle: "二级标题",
  showImage: "http://www.wsgjp.com.cn/Products/img/index/advantage_bg.png",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "小标题", remark: "", field: "subTitle", type: "text" },
    { name: "介绍图片", remark: "建议542 × 344尺寸", field: "showImage", type: "image" },
  ],
  field: [
    { name: "标题1", remark: "", field: "title1", type: "text" },
    { name: "标题2", remark: "", field: "title2", type: "text" },
  ],
  children: [
    {
      title1: "介绍1",
      title2: "内容1",
    },
    {
      title1: "介绍2",
      title2: "内容2",
    },
    {
      title1: "介绍3",
      title2: "内容3",
    },
    {
      title1: "介绍4",
      title2: "内容4",
    },
  ],
}
var template3Default =
{
  templateName: "templates3",
  templateCN: "产品模板3",
  FirstTitle: "大标题",
  subTitle: "二级标题",
  showImage: "http://www.wsgjp.com.cn/Products/img/index/customer_case_bg.png?v=1",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "小标题", remark: "", field: "subTitle", type: "text" },
    { name: "介绍图片", remark: "建议1199 × 412尺寸", field: "showImage", type: "image" },
  ],
  field: [
  ],
  children: [
  ],
}

var template4Default =
{
  templateName: "templates4",
  templateCN: "产品模板4",
  FirstTitle: "大标题",
  subTitle: "二级标题",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "二级标题", remark: "", field: "subTitle", type: "text" },
  ],
  field: [
    { name: "图片", remark: "	建议130×140尺寸", field: "image", type: "image" },
    { name: "介绍", remark: "50字", field: "introduce", type: "text" },
  ],
  children: [
    {
      image: "	http://www.wsgjp.com.cn/Products/img/index/honor_3.png",
      introduce: "示例1",
    },
    {
      image: "	http://www.wsgjp.com.cn/Products/img/index/honor_3.png",
      introduce: "示例2",
    },
    {
      image: "	http://www.wsgjp.com.cn/Products/img/index/honor_3.png",
      introduce: "示例3",
    },
    {
      image: "	http://www.wsgjp.com.cn/Products/img/index/honor_3.png",
      introduce: "示例4",
    },
    {
      image: "	http://www.wsgjp.com.cn/Products/img/index/honor_3.png",
      introduce: "示例5",
    },
    {
      image: "	http://www.wsgjp.com.cn/Products/img/index/honor_3.png",
      introduce: "示例6",
    },
  ],
}

var template5Default =
{
  templateName: "templates5",
  templateCN: "产品模板5",
  FirstTitle: "大标题",
  subTitle: "二级标题",
  btnUrl1: "https://www.cnitpm.com/pm1/71269.html",
  btnUrl1Name: "免费试用",
  btnUrl2Name: "实例演示",
  btnUrl2: "https://www.cnitpm.com/pm1/71269.html",
  showImage: "http://www.wsgjp.com.cn/Products/img/jxc-code.png",
  bgcImage: "http://www.wsgjp.com.cn/Products/img/drp/banner.jpg",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "小标题", remark: "", field: "subTitle", type: "text" },
    { name: "按钮1标题", remark: "", field: "btnUrl1Name", type: "text" },
    { name: "按钮1", remark: "", field: "btnUrl1", type: "text" },
    { name: "按钮2标题", remark: "", field: "btnUrl2Name", type: "text" },
    { name: "按钮2", remark: "", field: "btnUrl2", type: "text" },
    { name: "二维码图片", remark: "建议160×50尺寸", field: "showImage", type: "image" },
    { name: "背景图片", remark: "", field: "bgcImage", type: "image",children:[
      {
        lab:"背景图片1",
        value:"11"
      },
      {
        lab:"背景图片2",
        value:"22"
      }
    ] },

  ],
  field: [
  ],
  children: [
  ],
}

var template6Default =
{
  templateName: "templates6",
  templateCN: "产品模板6",
  FirstTitle: "大标题",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
  ],
  field: [
    { name: "图标", remark: "建议138×138尺寸", field: "icon", type: "image" },
    { name: "标题1", remark: "", field: "title1", type: "text" },
    { name: "标题2", remark: "", field: "title2", type: "text" },
  ],
  children: [
    {
      icon: "http://www.wsgjp.com.cn/Products/img/drp/tradition_1.png",
      title1: "示例1",
      title2: "内容1",
    },
    {
      icon: "	http://www.wsgjp.com.cn/Products/img/drp/tradition_2.png",
      title1: "示例2",
      title2: "内容2",
    },
    {
      icon: "http://www.wsgjp.com.cn/Products/img/drp/tradition_3.png",
      title1: "示例3",
      title2: "内容3",
    },
    {
      icon: "	http://www.wsgjp.com.cn/Products/img/drp/tradition_4.png",
      title1: "示例4",
      title2: "内容4",
    },
  ],
}
var template7Default =
{
  templateName: "templates7",
  templateCN: "产品模板7",
  FirstTitle: "大标题",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
  ],
  field: [
    { name: "标题1", remark: "", field: "title1", type: "text" },
    { name: "标题2", remark: "", field: "title2", type: "text" },
    { name: "试用链接", remark: "", field: "btnUrl", type: "text" },
    { name: "图片", remark: "建议500×307尺寸", field: "image", type: "image" },
  ],
  children: [
    {
      title1: "介绍1",
      title2: "内容1",
      btnUrl: "https://www.cnitpm.com/pm1/71269.html",
      image: "http://www.wsgjp.com.cn/Products/img/drp/function_1.png",
    },
    {
      title1: "介绍2",
      title2: "内容2",
      btnUrl: "https://www.cnitpm.com/pm1/71269.html",
      image: "https://www.wsgjp.com.cn/Products/img/drp/function_2.png",
    },
    {
      title1: "介绍3",
      title2: "内容3",
      btnUrl: "https://www.cnitpm.com/pm1/71269.html",
      image: "	https://www.wsgjp.com.cn/Products/img/drp/function_3.png",
    },
    {
      title1: "介绍4",
      title2: "内容4",
      btnUrl: "https://www.cnitpm.com/pm1/71269.html",
      image: "https://www.wsgjp.com.cn/Products/img/drp/function_4.png",
    },
  ],
}

var template8Default =
{
  templateName: "templates8",
  templateCN: "产品模板8",
  FirstTitle: "大标题",
  bgcImage: "http://www.wsgjp.com.cn/Products/img/drp/advantage_bg.jpg",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "背景图片", remark: "建议1900×583尺寸", field: "bgcImage", type: "image" },
  ],
  field: [
    { name: "图片", remark: "建议500×307尺寸", field: "image", type: "image" },
    { name: "标题", remark: "", field: "title", type: "text" },

  ],
  children: [
    {
      image: "http://www.wsgjp.com.cn/Products/img/drp/advantage_1.png",
      title: "示例1",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/drp/advantage_2.png",
      title: "示例2",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/drp/advantage_3.png",
      title: "示例3",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/drp/advantage_4.png",
      title: "示例4",
    },
  ],
}

var template9Default =
{
  templateName: "templates9",
  templateCN: "产品模板9",
  FirstTitle: "标题",
  btnUrl1: "https://www.cnitpm.com/pm1/71269.html",
  btnUrl2: "https://www.cnitpm.com/pm1/71269.html",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "试用链接", remark: "", field: "btnUrl1", type: "text" },
    { name: "试用链接", remark: "", field: "btnUrl2", type: "text" },
  ],
  field: [
  ],
  children: [
  ],
}


var template10Default =
{
  templateName: "templates10",
  templateCN: "产品模板10",
  FirstTitle: "标题",
  bgcImage: "	http://www.wsgjp.com.cn/Products/img/price/banner.jpg",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "背景图片", remark: "建议1900×289尺寸", field: "bgcImage", type: "image" },
  ],
  field: [
  ],
  children: [
  ],
}
var template11Default =
{
  templateName: "templates11",
  templateCN: "产品模板11",
  FirstTitle: "大标题",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
  ],
  field: [
    { name: "标题1", remark: "", field: "title1", type: "text" },
    { name: "标题2", remark: "", field: "title2", type: "text" },
    { name: "展示图片", remark: "", field: "image", type: "image" },
  ],
  children: [
    {
      title1: "示例1",
      title2: "内容1",
      image: "	https://www.wsgjp.com.cn/cloudApp/images/cloudApp/function_1.png"
    },
    {
      title1: "示例2",
      title2: "内容2",
      image: "	https://www.wsgjp.com.cn/cloudApp/images/cloudApp/function_2.png"
    },
    {
      title1: "示例3",
      title2: "内容3",
      image: "https://www.wsgjp.com.cn/cloudApp/images/cloudApp/function_3.png"
    },
    {
      title1: "示例4",
      title2: "内容4",
      image: "https://www.wsgjp.com.cn/cloudApp/images/cloudApp/function_4.png"
    },
    {
      title1: "示例5",
      title2: "内容5",
      image: "	https://www.wsgjp.com.cn/cloudApp/images/cloudApp/function_5.png"
    },
  ],
}



var template12Default =
{
  templateName: "templates12",
  templateCN: "产品模板12",
  table: [],
  field: [
    { name: "图片链接",  remark: "建议1199 × 412尺寸", field: "image", type: "image" },
    { name: "跳转链接", field: "url", type: "text" },
  ],
  children: [
    {
      url: "此处填写跳转链接",
      image: "	https://www.wsgjp.com.cn/cloudApp/images/cloudApp/function_5.png"
    }
  ],
}



var template13Default =
{
  templateName: "templates13",
  templateCN: "产品模板13",
  FirstTitle: "大标题",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
  ],
  field: [
    { name: "图片", remark: "建议97×88尺寸", field: "image", type: "image" },
    { name: "标题", remark: "", field: "title", type: "text" },
    { name: "介绍", remark: "", field: "produce", type: "text" },
  ],
  children: [
    {
      image: "https://www.wsgjp.com.cn/Products/img/erp/value_1.png",
      title: "示例1",
      produce: "介绍1",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/img/erp/value_2.png",
      title: "示例2",
      produce: "介绍2",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/erp/value_3.png",
      title: "示例3",
      produce: "介绍3",
    },
  ],
}


var template14Default =
{
  templateName: "templates14",
  templateCN: "产品模板14",
  FirstTitle: "大标题",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
  ],
  field: [
    { name: "图片", remark: "建议97×88尺寸", field: "image", type: "image" },
    { name: "标题", remark: "", field: "title", type: "text" },
    { name: "介绍", remark: "", field: "produce", type: "text" },
  ],
  children: [
    {
      image: "	https://www.wsgjp.com.cn/Products/img/erp/func_1.png",
      title: "示例1",
      produce: "介绍1",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/img/erp/func_2.png",
      title: "示例2",
      produce: "介绍2",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/erp/func_3.png",
      title: "示例3",
      produce: "介绍3",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/erp/func_4.png",
      title: "示例4",
      produce: "介绍4",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/img/erp/func_5.png",
      title: "示例5",
      produce: "介绍5",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/img/erp/func_6.png",
      title: "示例6",
      produce: "介绍6",
    },
  ],
}



var template15Default =
{
  templateName: "templates15",
  templateCN: "产品模板15",
  FirstTitle: "大标题",
  bgcImage: "https://www.wsgjp.com.cn/Products/img/erp/case_bg.jpg",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "背景图片", remark: "建议1900×650尺寸", field: "bgcImage", type: "image" },
  ],
  field: [
    { name: "图片", remark: "建议	1900 × 776 尺寸", field: "image", type: "image" },
    { name: "标题", remark: "", field: "title", type: "text" },
    { name: "介绍", remark: "", field: "produce", type: "text" },
  ],
  children: [
    {
      image: "https://www.wsgjp.com.cn/Products/img/erp/case_1.png?v=1",
      title: "示例1",
      produce: "介绍1",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/erp/case_2.png",
      title: "示例2",
      produce: "介绍2",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/erp/case_3.png",
      title: "示例3",
      produce: "介绍3",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/img/erp/case_4.png",
      title: "示例4",
      produce: "介绍4",
    },
  ],
}
var template16Default =
{
  templateName: "templates16",
  templateCN: "产品模板16",
  FirstTitle: "标题",
  bgcImage: "	https://www.wsgjp.com.cn/Products/img/erp/price_bg.jpg",
  btnUrl1: "https://www.cnitpm.com/pm1/71269.html",
  btnUrl2: "https://www.cnitpm.com/pm1/71269.html",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "背景图片", remark: "建议1900 × 206尺寸", field: "bgcImage", type: "image" },
    { name: "试用链接", remark: "", field: "btnUrl1", type: "text" },
    { name: "试用链接", remark: "", field: "btnUrl2", type: "text" },
  ],
  field: [
  ],
  children: [
  ],
}


var template17Default =
{
  templateName: "templates17",
  templateCN: "产品模板17",
  FirstTitle: "大标题",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
  ],
  field: [
    { name: "图片", remark: "建议	1900 × 776 尺寸", field: "image", type: "image" },
    { name: "标题", remark: "", field: "title", type: "text" },

  ],
  children: [
    {
      image: "	https://www.wsgjp.com.cn/Products/img/drp/industry_1.png",
      title: "示例1",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/drp/industry_2.png",
      title: "示例2",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/drp/industry_3.png",
      title: "示例3",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/drp/industry_4.png",
      title: "示例4",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/drp/industry_5.png",
      title: "示例5",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/drp/industry_6.png",
      title: "示例6",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/drp/industry_7.png",
      title: "示例7",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/img/drp/industry_8.png",
      title: "示例8",
    },

  ],
}


var template18Default =
{
  templateName: "templates18",
  templateCN: "产品模板18",
  produce: "文本介绍",
  bgcImage: "https://www.wsgjp.com.cn/Products/img/cloudFinance/di.png",

  table: [
    { name: "文本介绍", remark: "", field: "produce", type: "text" },
    { name: "介绍图片", remark: "", field: "bgcImage", type: "image" },
  ],
  field: [
    { name: "图片", remark: "建议	825 × 162 尺寸", field: "image", type: "image" },
    { name: "标题", remark: "", field: "title", type: "text" },

  ],
  children: [
    {
      image: "	https://www.wsgjp.com.cn/Products/img/cloudFinance/system_1.png",
      title: "示例1",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/cloudFinance/system_2.png",
      title: "示例2",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/cloudFinance/system_3.png",
      title: "示例3",
    },
  ],
}


var template19Default =
{
  templateName: "templates19",
  templateCN: "产品模板19",
  title1: "标题1",
  title2: "标题2",
  subTitle: "二级标题",
  bgcImage: "https://www.wsgjp.com.cn/Products/img/cloudFinance/finance_bg.jpg",
  vsImage: "	https://www.wsgjp.com.cn/Products/img/cloudFinance/finance_vs.png",
  btnUrl: "https://www.cnitpm.com/pm/31513.html",
  table: [
    { name: "标题1", remark: "", field: "title1", type: "text" },
    { name: "标题2", remark: "", field: "title2", type: "text" },
    { name: "二级标题", remark: "", field: "subTitle", type: "text" },
    { name: "背景图片", remark: "建议1900 × 740尺寸", field: "bgcImage", type: "image" },
    { name: "vs图片", remark: "固定102 × 62 尺寸", field: "vsImage", type: "image" },
    { name: "试用链接", remark: "", field: "btnUrl", type: "text" },
  ],
  field: [
    { name: "图标", remark: "建议51 × 50尺寸", field: "image", type: "image" },
    { name: "小标题", remark: "", field: "subTitle", type: "text" },
    { name: "0为左，1为右", remark: "", field: "lf", type: "text" },
  ],

  children: [
    {
      image: "	https://www.wsgjp.com.cn/Products/img/cloudFinance/finance_1.png",
      subTitle: "小标题1",
      lf:0
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/cloudFinance/finance_2.png",
      subTitle: "小标题2",
      lf:0

    },
    {
      image: "https://www.wsgjp.com.cn/Products/img/cloudFinance/finance_3.png",
      subTitle: "小标题3",
      lf:0

    },
    {
      image: "https://www.wsgjp.com.cn/Products/img/cloudFinance/finance_4.png",
      subTitle: "小标题4",
      lf:1
    },
    {
      image: "https://www.wsgjp.com.cn/Products/img/cloudFinance/finance_5.png",
      subTitle: "小标题5",
      lf:1

    },
  ]
}



var template20Default =
{
  templateName: "templates20",
  templateCN: "产品模板20",
  FirstTitle: "大标题",
  bgcImage: "https://www.wsgjp.com.cn/Products/img/cloudFinance/function_bg.jpg",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "背景图片", remark: "建议1900 × 890 尺寸", field: "bgcImage", type: "image" },
  ],
  field: [
    { name: "图片", remark: "建议99 × 99尺寸", field: "image", type: "image" },
    { name: "标题", remark: "", field: "title", type: "text" },
    { name: "介绍", remark: "", field: "produce", type: "text" },
  ],
  children: [
    {
      image: "	https://www.wsgjp.com.cn/Products/img/cloudFinance/function_1.png",
      title: "示例1",
      produce: "介绍1",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/cloudFinance/function_2.png",
      title: "示例2",
      produce: "介绍2",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/img/cloudFinance/function_3.png",
      title: "示例3",
      produce: "介绍3",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/img/cloudFinance/function_4.png",
      title: "示例4",
      produce: "介绍4",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/img/cloudFinance/function_5.png",
      title: "示例5",
      produce: "介绍5",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/cloudFinance/function_6.png",
      title: "示例6",
      produce: "介绍6",
    },

  ],
}
var template21Default =
{
  templateName: "templates21",
  templateCN: "产品模板21",
  FirstTitle: "大标题",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
  ],
  field: [
    { name: "图片", remark: "建议68 × 58 尺寸", field: "image", type: "image" },
    { name: "标题", remark: "", field: "title", type: "text" },
    { name: "介绍", remark: "", field: "produce", type: "text" },
  ],
  children: [
    {
      image: "	https://www.wsgjp.com.cn/Products/img/cloudFinance/love.png",
      title: "示例1",
      produce: "介绍1",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/cloudFinance/use.png",
      title: "示例2",
      produce: "介绍2",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/img/cloudFinance/efficient.png",
      title: "示例3",
      produce: "介绍3",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/img/cloudFinance/wechat.png",
      title: "示例4",
      produce: "介绍4",
    },
  ],
}

var template22Default =
{
  templateName: "templates22",
  templateCN: "产品模板22",
  FirstTitle: "大标题",
  produce:"文本介绍",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "介绍", remark: "", field: "produce", type: "text" },
  ],
  field: [
    { name: "图片", remark: "建议97 × 92尺寸", field: "image", type: "image" },
    { name: "标题1", remark: "", field: "title", type: "text" },
  ],
  children: [
    {
      image: "https://www.wsgjp.com.cn/cloudApp/images/cloudApp/advantage_1.png",
      title: "标题1",
    },
    {
      image: "	https://www.wsgjp.com.cn/cloudApp/images/cloudApp/advantage_2.png",
      title: "标题2",
    },
    {
      image: "https://www.wsgjp.com.cn/cloudApp/images/cloudApp/advantage_3.png",
      title: "标题3",
    },
    {
      image: "	https://www.wsgjp.com.cn/cloudApp/images/cloudApp/advantage_4.png",
      title: "标题4",
    },
  ],
}

var template23Default =
{
  templateName: "templates23",
  templateCN: "产品模板23",
  FirstTitle: "大标题",
  subTitle: "二级标题",
  bgcImage:"	https://www.wsgjp.com.cn/Products/img/wmsBasis/vs.png",
  title1:"标题1",
  produce1:"介绍1",
  title2:"标题2",
  produce2:"介绍2",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "二级标题", remark: "", field: "subTitle", type: "text" },
    { name: "背景图片", remark: "建议	337 × 295尺寸", field: "bgcImage", type: "image" },
    { name: "标题1", remark: "", field: "title1", type: "text" },
    { name: "介绍1", remark: "50字", field: "produce1", type: "text" },
    { name: "标题2", remark: "", field: "title2", type: "text" },
    { name: "介绍2", remark: "50字", field: "produce2", type: "text" },
  ],
  field: [
  ],
  children: [
  ],
}


var template24Default =
{
  templateName: "templates24",
  templateCN: "产品模板24",
  FirstTitle: "大标题",
  subTitle: "二级标题",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "二级标题", remark: "", field: "subTitle", type: "text" },

  ],
  field: [
    { name: "文字", remark: "", field: "characters", type: "text" },
    { name: "小标题", remark: "", field: "title", type: "text" },
    { name: "介绍", remark: "50字", field: "introduce1", type: "text" },
    { name: "介绍", remark: "50字", field: "introduce2", type: "text" },
    { name: "展示图片", remark: "建议463 × 483尺寸", field: "showImage", type: "image" },
  ],
  children: [
    {
      characters: "文字1",
      title: "标题1",
      introduce1: "文本介绍1",
      introduce2: "文本介绍2",
      showImage:
        "https://www.wsgjp.com.cn/Products/img/wmsBasis/function_list_1.png",
   
    },
    {
      characters: "文字1",
      title: "标题1",
      introduce1: "文本介绍1",
      introduce2: "文本介绍2",
      showImage:
        "https://www.wsgjp.com.cn/Products/img/wmsBasis/function_list_2.png",
   
    },
    {
      characters: "文字1",
      title: "标题1",
      introduce1: "文本介绍1",
      introduce2: "文本介绍2",
      showImage:
        "https://www.wsgjp.com.cn/Products/img/wmsBasis/function_list_3.png",
   
    },
    {
      characters: "文字1",
      title: "标题1",
      introduce1: "文本介绍1",
      introduce2: "文本介绍2",
      showImage:
        "https://www.wsgjp.com.cn/Products/img/wmsBasis/function_list_4.png",
   
    },
    {
      characters: "文字1",
      title: "标题1",
      introduce1: "文本介绍1",
      introduce2: "文本介绍2",
      showImage:
        "https://www.wsgjp.com.cn/Products/img/wmsBasis/function_list_5.png",
   
    },
  ],
}

var template25Default =
{
  templateName: "templates25",
  templateCN: "产品模板25",
  FirstTitle: "大标题",
  subTitle: "二级标题",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "小标题", remark: "", field: "subTitle", type: "text" },
  ],
  field: [
    { name: "图片", remark: "	建议	70 × 70尺寸", field: "image", type: "image" },
    { name: "介绍", remark: "50字", field: "introduce", type: "text" },
  ],
  children: [
    {
      image: "	https://www.wsgjp.com.cn/Products/CloudRetail/img/industry/01.png",
      introduce: "示例1",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/CloudRetail/img/industry/02.png",
      introduce: "示例2",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/CloudRetail/img/industry/03.png",
      introduce: "示例3",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/CloudRetail/img/industry/04.png",
      introduce: "示例4",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/CloudRetail/img/industry/05.png",
      introduce: "示例5",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/CloudRetail/img/industry/07.png",
      introduce: "示例6",
    },
  ],
}

var template26Default =
{
  templateName: "templates26",
  templateCN: "产品模板26",
  FirstTitle: "大标题",
  subTitle: "二级标题",
  bgcImage:"https://www.wsgjp.com.cn/Products/CloudRetail/img/function.jpg",
  table: [
    { name: "大标题", remark: "", field: "FirstTitle", type: "text" },
    { name: "二级标题", remark: "", field: "subTitle", type: "text" },
    { name: "背景图片", remark: "建议1900 × 797尺寸", field: "bgcImage", type: "image" },
  ],
  field: [
    { name: "图片", remark: "	建议98 × 98尺寸", field: "image", type: "image" },
    { name: "小标题", remark: "", field: "title", type: "text" },
    { name: "介绍", remark: "50字", field: "introduce", type: "text" },
  ],
  children: [
    {
      image: "https://www.wsgjp.com.cn/Products/CloudRetail/img/function/01.png",
      title:"标题1",
      introduce: "示例1",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/CloudRetail/img/function/02.png",
      title:"标题2",
      introduce: "示例2",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/CloudRetail/img/function/03.png",
      title:"标题3",
      introduce: "示例3",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/CloudRetail/img/function/04.png",
      title:"标题4",
      introduce: "示例4",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/CloudRetail/img/function/05.png",
      title:"标题5",
      introduce: "示例5",
    },
    {
      image: "https://www.wsgjp.com.cn/Products/CloudRetail/img/function/05.png",
      title:"标题6",
      introduce: "示例6",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/CloudRetail/img/function/07.png",
      title:"标题7",
      introduce: "示例7",
    },
    {
      image: "	https://www.wsgjp.com.cn/Products/CloudRetail/img/function/08.png",
      title:"标题8",
      introduce: "示例8",
    },

  ],
}
var template27Default =
{
  templateName: "templates27",
  templateCN: "产品模板27",
  showImage1: "	https://www.wsgjp.com.cn/Products/img/increment/content_01.png",
  showImage2: "https://www.wsgjp.com.cn/Products/img/increment/content_02.png?v=1",
  showImage3:"	https://www.wsgjp.com.cn/Products/img/increment/content_04.png",
	showImage4:"https://www.wsgjp.com.cn/Products/img/increment/content_06.png",
  table: [
    { name: "展示图片", remark: "建议1900 × 645尺寸", field: "showImage1", type: "image" },
    { name: "展示图片", remark: "建议1900 × 571尺寸", field: "showImage2", type: "image" },
    { name: "展示图片", remark: "建议1900 × 526尺寸", field: "showImage3", type: "image" },
    { name: "展示图片", remark: "建议1900 × 497尺寸", field: "showImage4", type: "image" },
  ],
  field: [
  ],
  children: [
  ],
}


let options = [{
  value: 0,
  template: template1Default,
  image: "img/templates/1.jpg",
  label: '模板1'
}, {
  value: 1,
  template: template2Default,
  image: "img/templates/2.jpg",

  label: '模板2'
}, {
  value: 2,
  template: template3Default,
  image: "img/templates/3.jpg",

  label: '模板3'
}, {
  value: 3,
  template: template4Default,
  image: "img/templates/4.jpg",

  label: '模板4'
}, {
  value: 4,
  template: template5Default,
  image: "img/templates/5.jpg",

  label: '模板5'
},
{
  value: 5,
  template: template6Default,
  image: "img/templates/6.jpg",

  label: '模板6'
},
{
  value: 6,
  template: template7Default,
  image: "img/templates/7.jpg",

  label: '模板7'
},
{
  value: 7,
  template: template8Default,
  image: "img/templates/8.jpg",

  label: '模板8'
},
{
  value: 8,
  template: template9Default,
  image: "img/templates/9.jpg",

  label: '模板9'
},
{
  value: 9,
  template: template10Default,
  image: "img/templates/10.jpg",

  label: '模板10'
},
{
  value: 10,
  template: template11Default,
  image: "img/templates/11.jpg",

  label: '模板11'
}, {
  value: 11,
  template: template12Default,
  image: "img/templates/12.jpg",

  label: '模板12'
}
  , {
  value: 12,
  template: template13Default,
  image: "img/templates/13.jpg",

  label: '模板13'
}
  , {
  value: 13,
  template: template14Default,
  image: "img/templates/14.jpg",

  label: '模板14'
}
  , {
  value: 14,
  template: template15Default,
  image: "img/templates/15.jpg",

  label: '模板15'
}
  , {
  value: 15,
  template: template16Default,
  image: "img/templates/16.jpg",

  label: '模板16'
}
  , {
  value: 16,
  template: template17Default,
  image: "img/templates/17.jpg",

  label: '模板17'
}
  , {
  value: 17,
  template: template18Default,
  image: "img/templates/18.jpg",

  label: '模板18'
}
  , {
  value: 18,
  template: template19Default,
  image: "img/templates/19.jpg",

  label: '模板19'
}
, {
  value: 19,
  template: template20Default,
  image: "img/templates/20.jpg",

  label: '模板20'
}
, {
  value: 20,
  template: template21Default,
  image: "img/templates/21.jpg",

  label: '模板21'
}
, {
  value: 21,
  template: template22Default,
  image: "img/templates/22.jpg",

  label: '模板22'
}
, {
  value: 22,
  template: template23Default,
  image: "img/templates/23.jpg",

  label: '模板23'
}
, {
  value: 23,
  template: template24Default,
  image: "img/templates/24.jpg",

  label: '模板24'
}
, {
  value: 24,
  template: template25Default,
  image: "img/templates/25.jpg",

  label: '模板25'
}
, {
  value: 25,
  template: template26Default,
  image: "img/templates/26.jpg",

  label: '模板26'
}
, {
  value: 26,
  template: template27Default,
  image: "img/templates/27.jpg",

  label: '模板27'
}
]
export { options, template1Default, template2Default, template3Default, template4Default, template5Default, template6Default, template7Default, template8Default, template9Default, template10Default, template11Default, template12Default, template13Default, template14Default, template15Default, template16Default, template17Default, template18Default, template19Default, template20Default, template21Default, template22Default, template23Default, template24Default, template26Default, template27Default}
